import { ff } from '@atlassian/jira-feature-flagging';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { ConfluenceSpace } from '../../../../common/types';
import { fireErrorAnalyticsEvents } from '../../../../common/utils';
import {
	getCreatePermissionsForSpace,
	getCreatePermissionsForSpaceOld,
} from '../../../../services';
import type { State } from '../../types';

const EVENT_NAME = 'createPermissionsForSpace';
export const fetchCreateArticlePermission =
	({
		cloudId,
		spaceKeys,
		createAnalyticsEvent,
	}: {
		cloudId: string;
		spaceKeys: string[];
		createAnalyticsEvent: () => void;
	}) =>
	async ({ setState, getState }: StoreActionApi<State>) => {
		const initialState = { ...getState() };
		setState({
			...initialState,
			spacesPermitted: { ...initialState.spacesPermitted, isLoading: true },
		});
		try {
			const { promotedSpaces } = await (ff('jira-service-desk-confluence-stargate')
				? getCreatePermissionsForSpace(cloudId, spaceKeys)
				: getCreatePermissionsForSpaceOld(spaceKeys));
			const permittedSpaces: ConfluenceSpace[] = promotedSpaces.spaces.map(
				// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'text' implicitly has an 'any' type.
				({ id, text }) => ({
					spaceKey: id,
					spaceName: text,
				}),
			);
			setState({
				...initialState,
				spacesPermitted: {
					...initialState.spacesPermitted,
					isLoading: false,
					data: permittedSpaces,
					totalSize: promotedSpaces.spaces.length,
				},
			});
			// @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
			fireTrackAnalytics(createAnalyticsEvent({}), `${EVENT_NAME} succedded`);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({
				...initialState,
				spacesPermitted: { ...initialState.spacesPermitted, isLoading: false, error },
			});
			fireErrorAnalyticsEvents(error, 'createSpacePermissions', 'knowledgeCommon');
		}
	};
